/**
 * Created by Admin on 26.02.2018.
 */
import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core'
import { NavLink, Redirect, Route, Switch, withRouter } from 'react-router-dom'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'

const styles = theme => ({
  container: {
    display: 'flex',
    height: '100%',
  },
  navigation: {
    minWidth: '250px',
    marginRight: 80,
  },
  body: {
    minWidth: '700px',
    width: '100%',
    marginRight: 40,
  },
  rootLink: {
    boxShadow: '4px 4px 29px rgba(19, 69, 186, 0.0855129)',
    borderRadius: 10,
    padding: 0,
    background: theme.defaults.contrastText,
  },
  link: {
    textDecoration: 'none',
    color: theme.defaults.text,
    border: 'none',
    '&:hover>div': {
      background: 'var(--color-hover-overlay-secondary)',
    },
    '&>div': {
      height: 70,
    },
    '&:first-child > div': {
      borderTopLeftRadius: 10,
      borderTopRightRadius: 10,
    },
    '&:last-child>div': {
      borderBottomLeftRadius: 10,
      borderBottomRightRadius: 10,
    },
  },
  activeLink: {
    // CareBrain (master) active state — secondary button colours.
    '& span': {
      color: 'var(--color-text-on-secondary)',
    },
    '& >div': {
      background: 'var(--color-button-secondary)',
    },
    '&:hover>div': {
      background: 'var(--color-button-secondary)',
    },
  },
  // QCS-only: pine-teal active row. Applied via activeClassName when isQcs.
  qcsActiveLink: {
    '& span': {
      color: 'var(--color-text-on-primary, #fff)',
    },
    '& >div': {
      background: 'var(--careco-primary)',
    },
    '&:hover>div': {
      background: 'var(--careco-primary)',
    },
  },
  child: {
    backgroundColor: 'var(--color-pressed-overlay-secondary)'
  }
})

class Submenu extends React.Component {
  render() {
    const { classes, routes, pathRoute, pathLink, isQcs } = this.props
    const activeClass = isQcs ? classes.qcsActiveLink : classes.activeLink

    return (
      <div>
        <div className={classes.container}>
          {routes.length > 1 && (
            <div className={classes.navigation}>
              <List className={classes.rootLink}>
                {routes.map(route => {
                  const label =
                    isQcs && route.path === 'surveysSupervision' ? 'Supervision' : route.name
                  return (
                  <NavLink
                    className={classes.link}
                    key={route.path}
                    activeClassName={activeClass}
                    to={`${pathLink}/${route.path}`}>
                    <ListItem
                      TouchRippleProps={{ classes: classes }}
                      button>
                      <ListItemText primary={label} />
                    </ListItem>
                  </NavLink>
                  )
                })}
              </List>
            </div>
          )}
          <div className={classes.body}>
            <Switch>
              {routes.map(({ path, component: Component }) => (
                <Route
                  exact
                  key={path}
                  path={`${pathRoute}${path}/:sourceType?/:sourceId?`}
                  render={props => <Component {...props} />}
                />
              ))}
              <Route
                exact
                path={pathRoute}
                render={props => (
                  <Redirect
                    to={{
                      pathname: `${pathLink}/${routes[0].path}`,
                      search: props.location.search,
                    }}
                  />
                )}
              />
            </Switch>
          </div>
        </div>
      </div>
    )
  }
}

Submenu.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  pathRoute: PropTypes.string.isRequired,
  pathLink: PropTypes.string,
  routes: PropTypes.array.isRequired,
  isQcs: PropTypes.bool,
}

Submenu.defaultProps = {
  isQcs: false,
}

export default withRouter(withStyles(styles, { withTheme: true })(Submenu))
